import React from 'react';
import { CartItemType } from '../types/types';
import { CONFIG } from '../data/config';
import { MinusIcon, PlusIcon, TrashIcon, EditIcon } from 'lucide-react';
interface CartItemProps {
  item: CartItemType;
  onUpdateQuantity: (id: string, delta: number) => void;
  onRemove: (id: string) => void;
  onEdit: (item: CartItemType) => void;
}
export function CartItem({
  item,
  onUpdateQuantity,
  onRemove,
  onEdit
}: CartItemProps) {
  const renderSelections = () => {
    const parts = [];
    const s = item.selections;
    if (s.base) parts.push(`Base: ${s.base.name}`);
    if (s.proteina) parts.push(`Proteína: ${s.proteina.name}`);
    if (s.toppings?.length) parts.push(`Toppings: ${s.toppings.map(t => t.name).join(', ')}`);
    if (s.toppingsPremium?.length) parts.push(`Premium: ${s.toppingsPremium.map(t => t.name).join(', ')}`);
    if (s.aderezos?.length) parts.push(`Aderezos: ${s.aderezos.map(t => t.name).join(', ')}`);
    if (s.semillas?.length) parts.push(`Semillas: ${s.semillas.map(t => t.name).join(', ')}`);
    if (s.comentarios) parts.push(`Nota: ${s.comentarios}`);
    if (parts.length === 0) return null;
    return <div className="text-xs text-gray-500 mt-1 space-y-0.5" data-id="element-90">
        {parts.map((part, i) => <p key={i} className="line-clamp-2" data-id="element-91">
            {part}
          </p>)}
      </div>;
  };
  return <div className="bg-white p-4 rounded-2xl border border-gray-100 shadow-sm mb-3" data-id="element-92">
      <div className="flex justify-between items-start mb-2" data-id="element-93">
        <h4 className="font-heading font-semibold text-gray-900" data-id="element-94">
          {item.name}
        </h4>
        <span className="font-bold text-verde-dark" data-id="element-95">
          {CONFIG.CURRENCY_SYMBOL}
          {(item.subtotal * item.quantity).toLocaleString()}
        </span>
      </div>

      {renderSelections()}

      <div className="flex items-center justify-between mt-4" data-id="element-96">
        <div className="flex items-center gap-2" data-id="element-97">
          {item.type === 'bowl' || item.type === 'sandwich' || item.type === 'wrap' ? <button onClick={() => onEdit(item)} className="text-terracota text-sm font-medium flex items-center gap-1 bg-terracota/10 px-3 py-1.5 rounded-lg hover:bg-terracota/20 transition-colors" data-id="element-98">
              <EditIcon className="w-3.5 h-3.5" data-id="element-99" /> Editar
            </button> : null}
          <button onClick={() => onRemove(item.id)} className="text-gray-400 hover:text-red-500 p-1.5 rounded-lg transition-colors" data-id="element-100">
            <TrashIcon className="w-4 h-4" data-id="element-101" />
          </button>
        </div>

        <div className="flex items-center bg-gray-100 rounded-full p-1" data-id="element-102">
          <button onClick={() => onUpdateQuantity(item.id, -1)} className="w-7 h-7 rounded-full bg-white flex items-center justify-center text-gray-600 shadow-sm" data-id="element-103">
            <MinusIcon className="w-3 h-3" data-id="element-104" />
          </button>
          <span className="w-8 text-center font-medium text-sm" data-id="element-105">
            {item.quantity}
          </span>
          <button onClick={() => onUpdateQuantity(item.id, 1)} className="w-7 h-7 rounded-full bg-white flex items-center justify-center text-gray-600 shadow-sm" data-id="element-106">
            <PlusIcon className="w-3 h-3" data-id="element-107" />
          </button>
        </div>
      </div>
    </div>;
}